// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".conversations[data-v-d729eeee]{overflow:visible !important}\n", ""]);
// Exports
module.exports = exports;
